import React from 'react';
import './Steps.css';

function Step1({ onNext }) {
  return (
    <div className="step-container">
      <div className="step-content">
        <div className="emoji-large">❤️</div>
        <h1 className="step-title">Step 1 – Identity Verification</h1>
        <h2 className="heading">🔐 Security Check</h2>
        <p className="text">"Before accessing this heart… please confirm something."</p>
        <p className="question">👉 "Are you the most beautiful person in my world?"</p>
        <div className="button-group">
          <button className="btn btn-primary" onClick={onNext}>
            Yes 💖
          </button>
          <button className="btn btn-secondary" onClick={onNext}>
            Obviously Yes 😌
          </button>
        </div>
      </div>
    </div>
  );
}

export default Step1;